// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"3054":"73e1d784","7742":"6554e0fe","7818":"ee3d8f6d"}[chunkId] + ".chunk.css");